const shouldKeepPromoLabelSpace = (recentlyViewedProducts) => {
    var _a;
    if ((_a = recentlyViewedProducts[0]) === null || _a === void 0 ? void 0 : _a.promotionalContent) {
        return recentlyViewedProducts.some(product => { var _a, _b; return !!((_b = (_a = product.promotionalContent) === null || _a === void 0 ? void 0 : _a.promoLabel) === null || _b === void 0 ? void 0 : _b.label); });
    }
    else {
        return recentlyViewedProducts.some(product => { var _a; return !!((_a = product.promoIcon) === null || _a === void 0 ? void 0 : _a.displayText); });
    }
};
export default shouldKeepPromoLabelSpace;
//# sourceMappingURL=shouldKeepPromoLabelSpace.js.map